/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { intl } from "../../services/intlGlobalProvider";
import { Accordion, Button, List, ActionSheet, Modal } from "antd-mobile";
import { connect } from "react-redux";
import LoadingIndicator from "../../components/LoadingIndicator";
import OrderGroupItem from "../../components/OrderGroupItem";
import ChangeTableModal from "../ChangeTableModal";
import * as selectors from "../../selectors";
import * as orderSelectors from "../../selectors/order";
import * as userAction from "../../actions/user";
import * as _ from "underscore";
import * as checkoutSelector from "../../selectors/checkout";
import Constant from "../../constants";
import Toast from "../../utils/Toast";
import IpayHelper from "../../utils/IpayHelper";
import Color from "../../utils/Color";
import Theme from "../../utils/Theme";
import "./index.css";
import * as userSelectors from "../../selectors/user";

const StyledContainer = styled.div`
  background: #f4f4f4;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  overflow-y: scroll;
`;

const StyledContentContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  padding: 5px 15px;
`;

const StyledListContainer = styled.div`
  background: #ddd;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items; stretch;
  border-radius: 5px;
  box-shadow: 2px 2px 2px -2px grey;
`;

const StyledListItem = styled.div`
  background: white;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px;
  line-height: 44px;
  margin-bottom: 1px;
`;

const StyledListTitle = styled.span`
  font-size: 1em;
  color: black;
`;

const StyledDescriptionWrap = styled.div``;

const StyledListDescription = styled.span`
  font-size: 0.85em;
  color: gray;
`;

const StyledChangeTable = styled.span`
  font-size: 0.85em;
  background: #3a53a4;
  color: #fff;
  padding: 7px 10px;
  border-radius: 2px;
  margin-left: 8px;
  cursor: pointer;
`;

const StyledSpaceBetweenContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledRoundedButton = styled(Button)`
  width: 100%;
  && {
    cursor: pointer;
    font-size: 1em !important;
    border-radius: 25px !important;
    color: white !important;
  }
`;

const StyledMakePaymentButton = styled(StyledRoundedButton)`
  align-self: center;
  margin-top: 35px;
  && {
    background-color: ${Theme.PrimaryColor};
  }
`;

const StyledCancelButton = styled(StyledRoundedButton)`
  align-self: center;
  margin-top: 15px;
  && {
    background-color: ${Theme.SecondaryColor};
  }
`;

const StyledRefreshButton = styled(StyledRoundedButton)`
  align-self: center;
  margin-top: 35px;
  && {
    background-color: ${Theme.TertiaryColor};
  }
`;

const StyledQueueButton = styled(StyledRoundedButton)`
  align-self: center;
  margin-top: 35px;
  && {
    background-color: ${Theme.TertiaryColor};
  }
`;

const Alert = Modal.alert;

const isIPhone = new RegExp("\\biPhone\\b|\\biPod\\b", "i").test(
  window.navigator.userAgent
);
let wrapProps;
if (isIPhone) {
  wrapProps = {
    onTouchStart: e => e.preventDefault()
  };
}

function closest(el, selector) {
  const matchesSelector =
    el.matches ||
    el.webkitMatchesSelector ||
    el.mozMatchesSelector ||
    el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class OrderSummaryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animationClass: null,
      paymentOptions: [intl.formatMessage({ id: "app.cancel" })]
    };
  }

  componentDidMount() {
    this.configureNavBar();
    this.setState({ animationClass: "slide-in-right" });
    this.fetchOrderDetailData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cancelOrderStatus !== nextProps.cancelOrderStatus) {
      if (nextProps.cancelOrderStatus) {
        this.fetchOrderDetailData();
      }
    }

    if (nextProps.orderDetailData !== this.props.orderDetailData) {
      if (nextProps.orderDetailData) {
        this.updateActionSheetPaymentMethods(nextProps.orderDetailData);
      }
    }

    if (nextProps.createPaymentStatus !== this.props.createPaymentStatus) {
      if (nextProps.createPaymentStatus) {
        const paymentGatewayCode = orderSelectors.getOrderPaymentGatewayCode(
          nextProps.createPaymentData
        );

        if (paymentGatewayCode === Constant.iPay88) {
          this.startIPay88(nextProps.createPaymentData);
        } else if (paymentGatewayCode === Constant.wallet) {
          this.startWalletPay(nextProps.createPaymentData);
        }
      }
    }

    if (!_.isEmpty(nextProps.QrCodeValue)) {
      this.onTableLocationSubmit(this.props.QrCodeValue);
    }
  }

  componentWillUnmount() {
    this.setState({
      paymentOptions: [intl.formatMessage({ id: "app.cancel" })]
    });
  }

  onWrapTouchStart = e => {
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, ".am-modal-content");
    if (!pNode) {
      e.preventDefault();
    }
  };

  configureNavBar = (title = null, liked = false) => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = (
      <span>
        <FormattedMessage id="order.summary.title" />
      </span>
    );

    navbarConfig(navTitle, null, null, () => this.onBackPressed(), null);
    showNavbar(true);
    showTabbar(false);
  };

  onBackPressed = () => {
    const { history, location } = this.props;
    const { search } = location;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      if (search && search.search("redirected")) {
        history.replace("/shop/stall");
      } else {
        history.goBack();
      }
    }, 300);
  };

  updateActionSheetPaymentMethods = orderDetailData => {
    const paymentGatewayItems = orderSelectors.getOrderPaymentGatewayItems(
      orderDetailData
    );

    let updatedPaymentOptions = [];

    /** To reset to initial state **/
    if (!paymentGatewayItems) {
      this.setState({
        paymentOptions: [intl.formatMessage({ id: "app.cancel" })]
      });
      return;
    }

    for (let i = 0; i < paymentGatewayItems.length; i++) {
      updatedPaymentOptions.push(paymentGatewayItems[i].name);
    }

    updatedPaymentOptions.push(intl.formatMessage({ id: "app.cancel" }));

    this.setState({
      paymentOptions: updatedPaymentOptions
    });
  };

  getOrderId = () => {
    const { match } = this.props;
    return match && match.params ? match.params.id : null;
  };

  getLoadingIndicator = () => {
    const {
      orderDetailLoading,
      updatePaymentLoading,
      cancelOrderLoading
    } = this.props;

    if (orderDetailLoading || updatePaymentLoading || cancelOrderLoading) {
      return <LoadingIndicator />;
    }

    return null;
  };

  fetchOrderDetailData = () => {
    const { getUserOrderDetailRequest } = this.props;
    const orderID = this.getOrderId();

    getUserOrderDetailRequest(orderID);
  };

  updateOrderPayment = (paymentID, data) => {
    const { updateUserOrderPayment } = this.props;

    updateUserOrderPayment(paymentID, data);
  };

  showPaymentMethodActionSheet = () => {
    const { paymentOptions } = this.state;

    ActionSheet.showActionSheetWithOptions(
      {
        options: paymentOptions,
        cancelButtonIndex: paymentOptions.length - 1,
        message: intl.formatMessage({ id: "order.summary.pay.with.title" }),
        maskClosable: true,
        "data-seed": "logId",
        wrapProps
      },
      buttonIndex => {
        this.onPressPaymentMethod(buttonIndex);
      }
    );
  };

  onCancelPressed = e => {
    Alert(
      intl.formatMessage({
        id: "order.summary.cancel.order.title"
      }),
      intl.formatMessage({
        id: "order.summary.cancel.order.description"
      }),
      [
        {
          text: intl.formatMessage({
            id: "app.cancel",
            defaultMessage: "Cancel"
          })
        },
        {
          text: intl.formatMessage({
            id: "app.ok",
            defaultMessage: "OK"
          }),
          onPress: () => {
            this.onPressCancelOrder();
          }
        }
      ]
    );
  };

  startIPay88 = createPaymentData => {
    const orderCurrentPaymentData = orderSelectors.getOrderPaymentData(
      createPaymentData
    );

    if (_.isEmpty(orderCurrentPaymentData)) {
      Toast.error(intl.formatMessage({ id: "app.not.available" }));
      return;
    }

    IpayHelper.checkout(orderCurrentPaymentData);
  };

  startWalletPay = data => {
    const paymentGatewayCode = orderSelectors.getOrderPaymentGatewayCode(data);
    const paymentToken = orderSelectors.getOrderPaymentToken(data);
    const paymentWalletToken = orderSelectors.getOrderPaymentWalletToken(data);
    const paymentID = orderSelectors.getOrderPaymentID(data);

    this.updateOrderPayment(paymentID, {
      gateway_code: paymentGatewayCode,
      token: paymentToken,
      data: {
        wallet_token: paymentWalletToken
      }
    });
  };

  onPressPaymentMethod = index => {
    const { orderDetailData, startOrderPaymentRequest, history } = this.props;
    const { paymentOptions } = this.state;

    const orderID = this.getOrderId();
    const paymentGatewayItems = orderSelectors.getOrderPaymentGatewayItems(
      orderDetailData
    );

    const selectedPaymentGatewayData = paymentGatewayItems.filter(gateway =>
      _.isEqual(gateway.name, paymentOptions[index])
    );

    if (_.isEmpty(selectedPaymentGatewayData)) {
      return;
    }

    const selectedPaymentGatewayCode = selectedPaymentGatewayData[0].code;

    if (selectedPaymentGatewayCode === Constant.iPay88) {
      startOrderPaymentRequest(orderID, {
        gateway_code: selectedPaymentGatewayCode
      });
    } else if (selectedPaymentGatewayCode === Constant.wallet) {
      startOrderPaymentRequest(orderID, {
        gateway_code: selectedPaymentGatewayCode
      });
    }
  };

  onPressMakePayment = () => {
    this.showPaymentMethodActionSheet();
  };

  onPressCancelOrder = () => {
    const { cancelUserOrderRequest } = this.props;
    const orderId = this.getOrderId();

    cancelUserOrderRequest && cancelUserOrderRequest(orderId);
  };

  onPressRefreshOrder = () => {
    this.fetchOrderDetailData();
  };

  onPressViewQueue = () => {
    const { history } = this.props;

    history && history.push("/shop/queue");
  };

  onTableLocationSubmit = tableNo => {
    const {
      updateOrderSummaryTableRequest,
      userCartItem,
      history
    } = this.props;

    const orderID = this.getOrderId();

    const currentTableCode = userSelectors.getUserOrderDetailItem(userCartItem);

    /** To avoid call api when user input is same as previous input **/
    if (currentTableCode === tableNo) {
      return;
    }
    let submitData = {
      code: tableNo
    };
    updateOrderSummaryTableRequest(orderID, submitData);

    history.push({
      state: { qrcodeValue: null }
    });
  };

  onClose = () => {
    const { updateChangeTableModalRequest } = this.props;

    updateChangeTableModalRequest(false);
  };

  showModal = e => {
    e.preventDefault();
    const { updateChangeTableModalRequest } = this.props;

    updateChangeTableModalRequest(true);
  };

  render() {
    const { animationClass, paymentOptions } = this.state;
    const {
      history,
      currentTable,
      orderDetailData,
      orderSummaryStatus,
      IsUpdatable
    } = this.props;

    const orderNumber = orderSelectors.getOrderNumber(orderDetailData);
    const orderTableCode = orderSelectors.getOrderTableCode(orderDetailData);
    const orderStatusName = orderSelectors.getOrderStatusName(orderDetailData);
    const orderTotal = orderSelectors.getOrderTotal(orderDetailData);
    const orderPaymentTotal = orderSelectors.getOrderPaymentTotal(
      orderDetailData
    );
    const orderPaymentBalanceTotal = orderSelectors.getOrderBalancePaymentTotal(
      orderDetailData
    );
    const orderSummaryItem = orderSelectors.getOrderSummaryItem(
      orderDetailData
    );
    const orderStallItems = orderSelectors.getOrderStall(orderDetailData);
    const isPayable = orderSelectors.getOrderAttributeIsPayable(
      orderDetailData
    );
    const isRefreshable = orderSelectors.getOrderAttributeIsRefreshable(
      orderDetailData
    );
    const isQueued = orderSelectors.getOrderAttributeIsQueued(orderDetailData);
    const isCancelable = orderSelectors.getOrderAttributeIsCancellable(
      orderDetailData
    );
    const orderQuantity = orderSelectors.getOrderTotalQuantity(orderTotal);
    return (
      <StyledContainer
        className={
          animationClass !== null
            ? "no-shrink-class " + animationClass
            : "no-shrink-class"
        }
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {this.getLoadingIndicator()}
        <ChangeTableModal
          history={history}
          shouldShow={orderSummaryStatus}
          orderID={this.getOrderId()}
          currentTable={currentTable}
          onClose={this.onClose}
          onTableValueSubmit={this.onTableLocationSubmit}
          onTouchStart={this.onWrapTouchStart}
        />
        <StyledContentContainer>
          <StyledListContainer>
            <StyledListItem>
              <StyledListTitle>
                <FormattedMessage id="order.summary.order.number" />
              </StyledListTitle>
              <StyledListDescription>{orderNumber}</StyledListDescription>
            </StyledListItem>
            <StyledListItem>
              <StyledListTitle>
                <FormattedMessage id="order.summary.order.status" />
              </StyledListTitle>
              <StyledListDescription style={{ color: Color.Primary }}>
                {orderStatusName}
              </StyledListDescription>
            </StyledListItem>
            {!_.isEmpty(orderSummaryItem) ? (
              <StyledListItem style={{ padding: 0 }}>
                <Accordion className="order-summary-total-amount-accordion">
                  <Accordion.Panel
                    header={
                      <StyledSpaceBetweenContainer
                        style={{ marginRight: "25px" }}
                      >
                        <StyledListTitle>
                          <FormattedMessage id="order.summary.total.amount" />
                        </StyledListTitle>
                        <StyledListDescription style={{ fontSize: "0.85em" }}>
                          {orderPaymentTotal}
                        </StyledListDescription>
                      </StyledSpaceBetweenContainer>
                    }
                  >
                    <List>
                      {!_.isEmpty(orderSummaryItem)
                        ? orderSummaryItem.map((summary, index) => {
                            const summaryText = checkoutSelector.getSummaryText(
                              summary
                            );
                            const summaryName = checkoutSelector.getSummaryName(
                              summary
                            );

                            return (
                              <List.Item key={index}>
                                <StyledSpaceBetweenContainer>
                                  <StyledListDescription
                                    style={{ fontSize: "0.75em" }}
                                  >
                                    {summaryName}
                                  </StyledListDescription>
                                  <StyledListDescription
                                    style={{ fontSize: "0.75em" }}
                                  >
                                    {summaryText}
                                  </StyledListDescription>
                                </StyledSpaceBetweenContainer>
                              </List.Item>
                            );
                          })
                        : false}
                    </List>
                  </Accordion.Panel>
                </Accordion>
              </StyledListItem>
            ) : (
              <StyledListItem>
                <StyledListTitle>
                  <FormattedMessage id="order.summary.total.amount" />
                </StyledListTitle>
                <StyledListDescription>
                  {orderPaymentTotal}
                </StyledListDescription>
              </StyledListItem>
            )}
            {orderPaymentBalanceTotal ? (
              <StyledListItem>
                <StyledListTitle>
                  <FormattedMessage id="order.summary.balance.total.amount" />
                </StyledListTitle>
                <StyledListDescription>
                  {orderPaymentBalanceTotal}
                </StyledListDescription>
              </StyledListItem>
            ) : (
              false
            )}
            {orderTableCode ? (
              <StyledListItem>
                <StyledListTitle>
                  <FormattedMessage id="order.summary.table.no" />
                </StyledListTitle>
                <StyledDescriptionWrap>
                  <StyledListDescription>
                    {orderTableCode}
                  </StyledListDescription>
                  {IsUpdatable ? (
                    <StyledChangeTable onClick={e => this.showModal(e)}>
                      <FormattedMessage id="order.summary.change.button" />
                    </StyledChangeTable>
                  ) : null}
                </StyledDescriptionWrap>
              </StyledListItem>
            ) : null}
            <StyledListItem style={{ padding: 0 }}>
              <Accordion className="order-summary-total-amount-accordion">
                <Accordion.Panel
                  header={
                    <StyledSpaceBetweenContainer
                      style={{ marginRight: "25px" }}
                    >
                      <StyledListTitle>
                        <FormattedMessage id="order.summary.order.items" />
                        <span
                          style={{
                            color: Color.favouriteColor,
                            marginLeft: "5px"
                          }}
                        >
                          <FormattedMessage
                            id="order.summary.order.items.qty"
                            values={{ qty: orderQuantity }}
                          />
                        </span>
                      </StyledListTitle>
                    </StyledSpaceBetweenContainer>
                  }
                >
                  <List className="order-summary-item-list">
                    {!_.isEmpty(orderStallItems)
                      ? orderStallItems.map((stallOrdered, index) => {
                          return (
                            <OrderGroupItem
                              key={index}
                              groupItem={stallOrdered}
                            />
                          );
                        })
                      : false}
                  </List>
                </Accordion.Panel>
              </Accordion>
            </StyledListItem>
          </StyledListContainer>
          {isPayable && paymentOptions && paymentOptions.length > 1 ? (
            <StyledMakePaymentButton
              activeStyle={{ backgroundColor: Theme.ActivePrimary }}
              onClick={this.onPressMakePayment}
            >
              <FormattedMessage id="order.summary.make.button.title" />
            </StyledMakePaymentButton>
          ) : (
            false
          )}
          {isCancelable ? (
            <StyledCancelButton
              activeStyle={{ backgroundColor: Theme.ActiveSecondary }}
              onClick={this.onCancelPressed}
            >
              <FormattedMessage id="app.cancel" />
            </StyledCancelButton>
          ) : (
            false
          )}
          {isRefreshable ? (
            <StyledRefreshButton
              activeStyle={{ backgroundColor: Theme.ActiveTertiary }}
              onClick={this.onPressRefreshOrder}
            >
              <FormattedMessage id="order.summary.refresh.button.title" />
            </StyledRefreshButton>
          ) : (
            false
          )}
          {isQueued ? (
            <StyledQueueButton
              activeStyle={{ backgroundColor: Theme.ActiveTertiary }}
              onClick={this.onPressViewQueue}
            >
              <FormattedMessage id="order.summary.queue.button.title" />
            </StyledQueueButton>
          ) : (
            false
          )}
        </StyledContentContainer>
      </StyledContainer>
    );
  }
}

OrderSummaryPage.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  intl: PropTypes.object,
  authToken: PropTypes.string,
  userCartItem: PropTypes.array,
  orderDetailData: PropTypes.object,
  orderDetailLoading: PropTypes.bool,
  updatePaymentLoading: PropTypes.bool,
  createPaymentStatus: PropTypes.bool,
  orderSummaryStatus: PropTypes.bool,
  createPaymentData: PropTypes.object,
  cancelOrderLoading: PropTypes.bool,
  cancelOrderStatus: PropTypes.bool,
  getUserOrderDetailRequest: PropTypes.func,
  updateChangeTableModalRequest: PropTypes.func,
  updateUserOrderPayment: PropTypes.func,
  startOrderPaymentRequest: PropTypes.func,
  cancelUserOrderRequest: PropTypes.func,
  updateOrderSummaryTableRequest: PropTypes.func,
  currentTable: PropTypes.string,
  changeTable: PropTypes.bool,
  QrCodeValue: PropTypes.object,
  IsUpdatable: PropTypes.bool
};

function mapStateToProps(state, props) {
  return {
    authToken: selectors.getAuthToken(state),
    orderDetailData: selectors.getUserOrderDetailItem(state),
    orderDetailLoading: selectors.getUserOrderDetailLoading(state),
    updatePaymentLoading: selectors.getUserOrderUpdatePaymentLoading(state),
    createPaymentStatus: selectors.getUserOrderCreatePaymentStatus(state),
    createPaymentData: selectors.getUserOrderCreatePaymentData(state),
    cancelOrderLoading: selectors.getCancelOrderLoading(state),
    cancelOrderStatus: selectors.getCancelOrderStatus(state),
    userCartItem: selectors.getUserCartItem(state),
    orderSummaryStatus: selectors.getOrderSummaryTableStatus(state),
    QrCodeValue: selectors.getOrderSummaryQrCode(state),
    IsUpdatable: selectors.getUserOrderIsTableUpdatable(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUserOrderDetailRequest: orderID =>
      dispatch(userAction.getUserOrderDetailRequest(orderID)),
    updateChangeTableModalRequest: status =>
      dispatch(userAction.updateChangeTableModalRequest(status)),
    updateUserOrderPayment: (paymentID, data) =>
      dispatch(userAction.updateUserOrderPaymentRequest(paymentID, data)),
    startOrderPaymentRequest: (orderID, data) =>
      dispatch(userAction.postUserOrderPaymentRequest(orderID, data)),
    cancelUserOrderRequest: orderID =>
      dispatch(userAction.cancelUserOrderRequest(orderID)),
    updateOrderSummaryTableRequest: (orderID, tableData) =>
      dispatch(userAction.updateOrderSummaryTableRequest(orderID, tableData))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OrderSummaryPage)
);



// WEBPACK FOOTER //
// ./src/containers/OrderSummaryPage/index.js